import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { Category, Tag, User } from "../../app/app.interfaces";
import { ApiService } from "../../services/api.service";
import { CategoryService } from "../../services/category.service";
import { TagService } from "../../services/tag.service";
import { UserService } from "../../services/user.service";


@Component({
  selector: 'tax-search',
  templateUrl: 'tax-search.component.html'
})
export class TaxSearchComponent implements OnChanges {

  @Input() searchTerm: string;

  foundCategories: Category[] = [];
  foundTags: Tag[] = [];
  foundUsers: User[] = [];

  constructor(
    private apiService: ApiService,
    private categoryService: CategoryService,
    private userService: UserService,
    private tagService: TagService) {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.searchTerm && this.searchTerm){
      this.doSearch();
    }
  }



  private async doSearch() {
    // console.log('do search: ' + this.searchTerm);

    this.foundTags = await this.tagService.searchByTitle(this.searchTerm);
    // console.log(this.foundTags);

    // this.foundCategories = await this.categoryService.searchByTitle(this.searchTerm);
    // console.log(this.foundCategories);
    //
    // this.foundUsers = await this.userService.searchUsersByName(this.searchTerm);
    // console.log(this.foundUsers);


  }



}



// WEBPACK FOOTER //
// ./src/components/tax-search/tax-search.component.ts